import React, { Component } from 'react';
import Badge from '@material-ui/core/Badge';
import { createStyles, withStyles, Theme } from '@material-ui/core/styles';
import { IFarmer, IMe, IPedido, IProduct, IProject } from '../Library/types';
import Loader from './Material/Loader';
import { withParamsAndNavigate } from './Material/ReactRouter';
import logo from '../Assets/icons/fa-refresh.svg';
import {AddDocument, RemoveDocument, GetDocument, GetDocuments} from '../Library/sp_firebase';
import background from '../Assets/images/agr.jpg';
import itemIcon from '../Assets/images/items.png';
import orderIcon from '../Assets/images/cesta.png';
import ExitApp from '@material-ui/icons/ExitToAppOutlined';
import pedidosIcon from '../Assets/images/pedido.png';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import CreateModal from './Material/CreateDialog';
import Layout from './Layout';
import {farmers} from '../ApiClients/DummyData';
import { cloneDeep, fill, filter, find, findIndex } from 'lodash';
import {readLocalStorage, writeLocalStorage} from '../Library/sp_general';
import { GetViewDefaultType } from '../Library/helpers';
import Translate from './Material/Traductor';

//import {GetLogoEmpresa} from '../Library/helpers';

const styles = (theme: Theme) => createStyles({
    badge: {
        top: '10px',
        right: '5px',
    }
});

interface IAccountProps {
    //history: any;
    //match: any;
    myInfo?: IMe;
    version: string;
    params?:any;
    navigate?:any;
    cart: Array<IProduct>;
    pedido: IPedido;
    addOrRemoveFromCart: Function;
    updateCart: Function;
    checkPermission:Function;
    allowed:boolean;
    lang:string;
}

interface IAccountState {
    loading: boolean;
    loadbeauty: boolean;
    modalType: number;
    typeAction: number;
    inputText: string;
    creationModalOpen: boolean;
    searchValue: string;
    viewType: number;
    titleModal:string;
}

class Farmers extends Component<IAccountProps, IAccountState> {
    constructor(props: IAccountProps) {
        super(props);
        this.state = {
            loading: true,
            loadbeauty: false,
            modalType: -1,
            typeAction: -1,
            inputText:'',
            creationModalOpen: false,
            searchValue: '',
            viewType: GetViewDefaultType(),
            titleModal: ''
        };
    }

    componentDidMount() {
        this.handleMyInfoChange();
    }

    componentDidUpdate = (prevprops:IAccountProps) => {
        if(prevprops.myInfo !== this.props.myInfo)
            this.handleMyInfoChange();
    }

    handleMyInfoChange = () => {
        if(this.props.myInfo === undefined || this.props.myInfo === null)
            return;
        this.props.checkPermission(this.props.myInfo)
        //this.loadData();
    }
    
    onCloseCreationModal = () => {
        this.setState({ creationModalOpen: false });
    }

    handleCreateModal = (typeAction: number) => {
        switch(typeAction) {
            case 1: // Cuando el modal implica el cierre de sesión de la app
                console.log('voy a cerrar sesión');
                break;
            default:
                break;
        }
    }

    account = (viewType:number, me:IMe) => {
        //console.log(me)
        const {lang} = this.props;;

        return (
            <div className='account-body'>
                <div className='account-data-text account-data-radius-top'>
                    <p className='p-data-text'>
                            <strong>
                                {`${Translate(lang, "account.title.01")}`}
                            </strong>
                    </p>
                    <p className='p-data-text'>
                        {`${me.profile == 20?`${Translate(lang, "account.text.01")}`:`${Translate(lang, "account.text.02")}`}`}
                    </p>
                </div>
                <div className='account-data-text'>
                    <p className='p-data-text'>
                        <strong>
                            {`${Translate(lang, "account.title.02")}`}
                        </strong>
                    </p>
                    <p className='p-data-text'>
                        {`${me.displayName}`}
                    </p>
                </div>
                {[20].indexOf(me.profile) > -1?
                    <div className='account-data-text'>
                        <p className='p-data-text'>
                            <strong>
                                {`${Translate(lang, "account.title.03")}`}
                            </strong>
                        </p>
                        <p className='p-data-text'>
                            {`${me.description}`}
                        </p>
                    </div>
                :
                    null
                }
                {[20].indexOf(me.profile) > -1?
                    <div className='account-data-text'>
                        <p className='p-data-text'>
                            <strong>
                                {`${Translate(lang, "account.title.04")}`}
                            </strong>
                        </p>
                        <div className='img-profile'>
                            <img
                                src={me.uri_img}
                            />
                        </div>
                    </div>
                :
                    null
                }
                <div className='account-data-text'>
                    <p className='p-data-text'>
                        <strong>
                            {`${Translate(lang, "account.title.05")}`}
                        </strong>
                    </p>
                    <p className='p-data-text'>
                        {`${me.email}`}
                    </p>
                </div>
                <div className='account-data-text'>
                    <p className='p-data-text'>
                        <strong>
                            {`${Translate(lang, "account.title.06")}`}
                        </strong>
                    </p>
                    <p className='p-data-text'>
                        {`${me.phone}`}
                    </p>
                </div>
                <div className='account-data-text account-data-text-end account-data-radius-bottom'>
                    <p className='p-data-text'>
                        <strong>
                            {`${Translate(lang, "account.title.07")}`}
                        </strong>
                    </p>
                    <p className='p-data-text'>
                        {`${me.activated?`${Translate(lang, "account.text.03")}`:`${Translate(lang, "account.text.04")}`}`}
                    </p>
                </div>
            </div>
        );
    }

    render() {
        const {myInfo, version, navigate, pedido, params } = this.props;
        const {loadbeauty, searchValue, viewType } = this.state;

        if(myInfo == null)
            console.log('Usuario no autorizado');
            
        return (
            <div>
                {/*TutorialExplication()*/}
                <Layout
                    navigate={navigate}
                    params={params}
                    placeholderSearch={""}
                    badgeAlarms={pedido.cart.length}
                    version={version}
                    searchValue={searchValue}
                    me={myInfo}
                />
                <div className='home-content'>

                    {/*this.home()*/}
                    {loadbeauty || !myInfo?
                        <div style={{marginLeft:'50%',marginTop:'10%'}}>
                            <Loader loading={this.state.loading}/>
                        </div>

                    :
                        this.account(viewType, myInfo)
                    }

                    <CreateModal
                            onCloseCreationModal={this.onCloseCreationModal}
                            isOpen={this.state.creationModalOpen}
                            inputText={this.state.inputText}
                            typeModal={this.state.modalType}
                            action={this.handleCreateModal}
                            typeAction={this.state.typeAction}
                            loadingModal={false}
                            titleModal={this.state.titleModal}
                        />
                </div>
            </div>
        );
    }
}

export default withParamsAndNavigate(Farmers);